import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class PersonalDetails extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 1
	}

	@computed get completed() {
		const { doctor } = this.props.store

		if (!(doctor.email)) { return false  }
		if (!(doctor.phone)) { return false  }
		
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push('/listing/new')
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2 >2. Contact Details</h2>
				<p>These are your direct personal contact details (not your clinic details).</p>

				<h4 className={`${this.error && 'error'} ${this.error && doctor.email && 'complete'}`} >
					Email:
				</h4>	
				<input
					className={`input medium m-r-1 ${this.error && 'error'} ${this.error && doctor.email && 'complete'}`}
					type="email"
					autoFocus
					placeholder="john.smith@medicalgroup.com.au"
					value={doctor.email}
					onChange={e => doctor.email = e.target.value}
				/>
				<select
					className="input small"
					value={doctor.emailPreference}
					onChange={e => doctor.emailPreference = e.target.value}>
					<option value="Yes">List my email</option>
					<option value="No">Don't list my email</option>
				</select>
				
				<h4>
					Website:
				</h4>	
				<input
					type="text"
					placeholder="https://www..."
					className={`input medium`}
					value={doctor.website}
					onChange={e => doctor.website = e.target.value} />
				
				<h4 className={`${this.error && "error"} ${this.error && doctor.phone && 'complete'}`}>
					Phone:
				</h4>	
				<input
					type="text"
					placeholder="(08) 9400..."
					className={`input small ${this.error && 'error'} ${this.error && doctor.phone && 'complete'}`}
					value={doctor.phone}
					onChange={e => doctor.phone = e.target.value} />
				
				<h4>
					Fax:
				</h4>	
				<input
					type="text"
					placeholder="(08) 9200..."
					className={`input small`}
					value={doctor.fax}
					onChange={e => doctor.fax = e.target.value} />
				
				<h4>
					Mobile:
				</h4>	
				<p className="m-b-1">Only registered practitioners will be able to see your mobile number. Listing your mobile so that referrers can contact you can improve your relationship with referrers. Please specify how you would like your mobile to be used:</p>
				<input
					type="text"
					placeholder="04..."
					className={`input small m-r-1`}
					value={doctor.mobile}
					onChange={e => doctor.mobile = e.target.value} />
				
				<select className="input medium" value={doctor.mobilePreference}
					onChange={e => doctor.mobilePreference = e.target.value}>
					<option value="Yes">Referrals and questions are welcome</option>
					<option value="Emergencies">For Emergencies only</option>
					<option value="No">Do not list my mobile number</option>
				</select>

				<div className="m-t-1">
					<button
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</button>
					<button
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</button>
				</div>
				
			</div>
		);
	}
}

export default PersonalDetails;


// WEBPACK FOOTER //
// ./src/Containers/Listing/2.ContactDetails.js